// extracted by mini-css-extract-plugin
var _1 = "bar__BN16U";
export { _1 as "bar" }
